import { api } from '../axiosInstance';
import { ApiErrorResponse } from '../type/commonTypes';

export const postLogout = async () => {
  const res = await api.post<ApiErrorResponse>(
    '/api/auth/logout',
    {},
    {
      headers: {
        'X-Auth-Method': 'COOKIE',
      },
    }
  );
  return res.data;
};
